module.exports = __webpack_public_path__ + "static/media/user_manage.4e000760.svg";